// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page404_wrapper__2eOwd","image":"Page404_image__PkIGw","button":"Page404_button__2-rF0"};